import * as React from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

import { CategoryContext, initDynamicYield, PageContext } from '@packages/shared';
import { useUserInteraction } from '@lib/hooks';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { Page } from '@packages/common';

const DYNAMIC_YIELD_ID = getPublicRuntimeConfig('DYNAMIC_YIELD_ID');

export const DyScripts: React.FC = () => {
  const { asPath } = useRouter();
  const { pageType } = React.useContext(PageContext);
  const { category, searchCategory } = React.useContext(CategoryContext);
  const categoryName = pageType === Page.category ? category.name : searchCategory?.name || '/';

  const enableDY = useUserInteraction({ timeoutSeconds: 10 });

  React.useEffect(() => {
    initDynamicYield(asPath, pageType, categoryName);

    if (!(window as any).renderDYComponent) {
      (window as any).renderDYComponent = function (name: any, target: any, props: any, callback: any) {
        if (!(window as any)._DYComponentsToRender) {
          (window as any)._DYComponentsToRender = [];
        }
        (window as any)._DYComponentsToRender.push({ name, target, props, callback });
      };
    }
  }, [asPath, categoryName, pageType]);

  if (enableDY) {
    return (
      <>
        <Script src={`//cdn-eu.dynamicyield.com/api/${DYNAMIC_YIELD_ID}/api_dynamic.js`} />
        <Script src={`//cdn-eu.dynamicyield.com/api/${DYNAMIC_YIELD_ID}/api_static.js`} />
      </>
    );
  }
  return null;
};
